import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/instructionalDesignAndAssessmentReport'

export default function InstructionalDesignAndAssessmentReport() {
  return <ProjectLayout data={data} />
}
